/**
 * Centralized API Error Handler Utility
 * Standardizes API error parsing across all feature modules and axios interceptors.
 *
 * @param {Error} error - Axios error object or standard JS Error
 * @returns {Object} Normalized error payload { message, status, details, isNetworkError }
 */
export const handleApiError = (error) => {
  let message = 'An unexpected error occurred. Please try again.';
  let status = null;
  let details = null;
  let isNetworkError = false;

  if (error.response) {
    // Server responded with an error status (4xx, 5xx)
    status = error.response.status;
    const data = error.response.data;

    if (typeof data === 'string') {
      message = data;
    } else if (data && typeof data === 'object') {
      message = data.message || data.error || data.detail || message;
      details = data.errors || data.details || null;
    }

    if (status === 401) {
      message = message || 'Session expired. Please log in again.';
    } else if (status === 403) {
      message = 'You do not have permission to perform this action.';
    } else if (status === 404) {
      message = 'The requested resource was not found.';
    } else if (status >= 500) {
      message = 'Server error. Our engineering team has been notified.';
    }
  } else if (error.request) {
    // Request was made but no response was received (Network / Timeout)
    isNetworkError = true;
    message = 'Network connection lost. Please check your internet connection.';
  } else if (error.message) {
    message = error.message;
  }

  // Log error for telemetry tracking
  console.error('[Centralized API Error]:', { status, message, details, raw: error });

  return {
    message,
    status,
    details,
    isNetworkError,
    raw: error
  };
};

export default handleApiError;
